module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.6-create.c2ab23c3.png";